/**
 *
 * PageState
 *
 * This component exists to temporarily track states across pages for other pages.
 */
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import makeSelectPageState from "./selectors";
import reducer from "./reducer";
import saga from "./saga";

export function PageState({ children }) {
  return children;
}

PageState.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
};

const mapStateToProps = createStructuredSelector({
  pageState: makeSelectPageState(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "pageState", reducer });
const withSaga = injectSaga({ key: "pageState", saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(PageState);
